import {Component, ViewChild} from '@angular/core';
import {DataTableComponent, Selectability, TableConfig} from '../../../components/data-table/data-table.component';
import {StringFilterComponent} from "../../../components/data-table/filters/string-filter/string-filter.component";
import {DateFilterComponent} from "../../../components/data-table/filters/date-filter/date-filter.component";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NumberFilterComponent} from "../../../components/data-table/filters/number-filter/number-filter.component";
import {ProductAmountsV1Service, ProductAmount, TaskType, Department} from "../../../apis/backend";
import {ListFilterComponent} from "../../../components/data-table/filters/list-filter/list-filter.component";
import {TaskTypeDialogComponent} from "../../tasks/type-dialog/task-type-dialog.component";
import {DataTableCellDirective} from "../../../components/data-table/cell/data-table-cell.component";
import {ProductAmountDialogComponent} from "../dialog/product-amount-dialog.component";

type FilterOption = {
  Value: string,
  Text: string
};

const preciseNumberFormat = new Intl.NumberFormat(
    'en-US',
    {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    });
const casualNumberFormat = new Intl.NumberFormat(
    'en-US',
    {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    });
const currencyFormat = new Intl.NumberFormat(
    'en-US',
    {
      style: 'currency',
      currency: 'USD',
    });

export const ProductAmountConfig: TableConfig = {
  ODataResourceName: 'product-amounts',
  Selectability: Selectability.SingleSelect,
  Columns: [
    {
      DisplayName: 'ID',
      PropertyName: 'ProductAmountID',
      FilterType: NumberFilterComponent,
      Formatter: (productAmountID: number) => {
        let ret = document.createElement('a');
        ret.href = '/product-amounts/' + productAmountID;
        ret.target = '_blank';
        ret.innerText = productAmountID.toString();
        return ret;
      }
    },
    {
      DisplayName: 'Type',
      PropertyName: 'ProductType/Name',
      FilterType: NumberFilterComponent,
    },
    {
      DisplayName: 'Composition',
      PropertyName: 'Composition',
      FilterType: StringFilterComponent
    },
    {
      DisplayName: 'Batch/Blend',
      PropertyName: 'Batch',
      FilterType: StringFilterComponent
    },
    {
      DisplayName: 'Barrel',
      PropertyName: 'Barrel/Name',
      FilterType: NumberFilterComponent,
    },
    {
      DisplayName: 'Date Filled',
      PropertyName: 'DateFilled',
      FilterType: DateFilterComponent,
      Formatter: (v) => new Date(v).toLocaleDateString()
    },
    {
      DisplayName: 'Gallons In',
      PropertyName: 'Gallons',
      FilterType: NumberFilterComponent,
    },
    {
      DisplayName: 'Proof in BBL',
      PropertyName: 'Proof',
      FilterType: NumberFilterComponent,
    },
    {
      DisplayName: 'Proof Gallons',
      PropertyName: 'ProofGallons',
      FilterType: NumberFilterComponent,
    },
    {
      DisplayName: 'Wine Gallons After Angel Share',
      PropertyName: 'GallonsAfterAngelShare',
      FilterType: NumberFilterComponent,
      Formatter: (v) => preciseNumberFormat.format(v),
    },
    {
      DisplayName: 'Proof Gallons After Angel Share',
      PropertyName: 'GallonsAfterAngelShare',
      FilterType: NumberFilterComponent,
      Formatter: (v) => preciseNumberFormat.format(v),
    },
    {
      DisplayName: '# Bottles @ 100 Proof',
      PropertyName: 'ProofBottlesAfterAngelShare',
      FilterType: NumberFilterComponent,
      Formatter: (v) => casualNumberFormat.format(v),
    },
  ]
}

@Component({
  selector: 'product-amount-overview',
  templateUrl: './product-amount-overview.component.html',
})
export class ProductAmountOverviewComponent {
  
  public TableConfig = ProductAmountConfig;

  public Prefilters: FilterOption[] = [
    {
      Value: 'IsActive eq true',
      Text: 'Active'
    },
    {
      Value: '',
      Text: 'All'
    },
  ];
  
  public Prefilter: string;
  public Filter: string;
  
  public PageIndex: number;
  public PageCount: number;
  
  @ViewChild(DataTableComponent)
  public DataTable: DataTableComponent;
  
  constructor(
      private _productAmountService: ProductAmountsV1Service,
      private _modalService: NgbModal) {
  }
  
  ngOnInit() {
    this.Prefilter = this.Prefilters[0].Value;
  }

  public CreateProductAmount() {
    this._modalService.open(ProductAmountDialogComponent, { size: 'lg' }).result
        .then((productAmount: ProductAmount) => {
          return firstValueFrom(this._productAmountService.createProductAmount(productAmount));
        })
        .then(() => {
          this.DataTable.Refresh();
        });
  }

  public EditProductAmount(productAmount?: ProductAmount) {
    if (!productAmount) {
      productAmount = this.DataTable.GetSelection();
    }
    if (productAmount) {
      productAmount = <ProductAmount>JSON.parse(JSON.stringify(productAmount));
      let modal = this._modalService.open(ProductAmountDialogComponent, { size: 'lg' });
      modal.componentInstance.ProductAmount = productAmount;

      modal.result
          .then((productAmount: ProductAmount) => {
            return firstValueFrom(this._productAmountService.updateProductAmount(productAmount.ProductAmountID, productAmount));
          })
          .then(() => {
            this.DataTable.Refresh();
          });
    }
  }
}
